
import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import locale from 'element-ui/lib/locale'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import enLocale from 'element-ui/lib/locale/lang/en'
import ruLocale from 'element-ui/lib/locale/lang/ru-RU'
import zh from './zh'
import en from './en'
import ru from './ru'

Vue.use(VueI18n)

let i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'zh',
  // locale: localStorage.getItem('language'),
  messages: {
    'zh': Object.assign(zh, zhLocale),
    'en': Object.assign(en, enLocale),
    'ru': Object.assign(ru, ruLocale)
  }
})
// locale.i18n((key, value) => i18n.t(key, value))
export default i18n;



// WEBPACK FOOTER //
// ./src/lang/index.js